require("/src/styles/global.css")
require("@fontsource/montserrat/400.css")
require("@fontsource/montserrat/500.css")
require("@fontsource/montserrat/600.css")
require("@fontsource/montserrat/700.css")

exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === "PUSH") {
    window.scrollTo(0, 0, "auto")
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.scrollTo(...(savedPosition || [0, 0]), "auto")
  }
  return false
}

exports.onInitialClientRender = () => {
  const Tawk_API = window.Tawk_API || {}
  const Tawk_LoadStart = new Date()
  window.Tawk_API = Tawk_API
  window.Tawk_LoadStart = Tawk_LoadStart
  ;(function () {
    const s1 = document.createElement("script"),
      s0 = document.getElementsByTagName("script")[0]
    s1.async = true
    s1.src = "https://embed.tawk.to/5a9e9d2cd7591465c7084e33/default"
    s1.charset = "UTF-8"
    s1.setAttribute("crossorigin", "*")
    s0.parentNode.insertBefore(s1, s0)
  })()
}
